import { API } from 'aws-amplify';
import { API_NAME, getConfig, handleError, validateResponse } from './apiUtils';

export function getRaffleReport(country, category, brand, fromDate, toDate) {
    const path = `/v1/loyaltyadmin/${country}/${category}/${brand}/report/raffle?fromDate=${fromDate}&toDate=${toDate}`;
    return getConfig()
        .then((config) => API.get(API_NAME, path, config))
        .then(validateResponse)
        .catch(handleError);
}

export function getWinnersReport(country, category, brand, fromDate, toDate) {
    const path = `/v1/loyaltyadmin/${country}/${category}/${brand}/report/prize-redeem?fromDate=${fromDate}&toDate=${toDate}`;
    return getConfig()
        .then((config) => API.get(API_NAME, path, config))
        .then(validateResponse)
        .catch(handleError);
}

export function getFreezeBlockReport(
    country,
    category,
    brand,
    fromDate,
    toDate,
    gigyaId = '',
    eventType = '',
    start = 0,
    limit = 10
) {
    let path = `/v1/loyaltyadmin/${country}/${category}/${brand}/freeze-block-history?fromDate=${fromDate}&toDate=${toDate}&start=${start}&limit=${limit}`;

    if (gigyaId) {
        path += `&gigyaId=${gigyaId}`;
    }

    if (eventType) {
        path += `&eventType=${eventType}`;
    }

    return getConfig()
        .then((config) => API.get(API_NAME, path, config))
        .then(validateResponse)
        .catch(handleError);
}
